import React, { useState } from 'react'
import ln1 from '../img/latest-new/l1.jpg'
import ln2 from '../img/latest-new/l2.jpg'
import ln3 from '../img/latest-new/l3.jpg'
import ln4 from '../img/latest-new/l4.jpg'
import ln5 from '../img/latest-new/l5.jpg'
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Slider from 'react-slick';


const LogoSlider = () => {
	const [settings] = useState({
		dots: false,
		infinite: true,
		slidesToShow: 4,
		slidesToScroll: 1,
		autoplay: true,
		speed: 5000,
		autoplaySpeed: 5000,
		cssEase: 'linear',
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3,
					infinite: true,
					dots: true,
				},
			},
			{
				breakpoint: 600,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2,
					initialSlide: 2,
				},
			},
			{
				breakpoint: 780,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
				},
			},
			{
				breakpoint: 580,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
				},
			},
			{
				breakpoint: 500,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				},
			},
		],
	});

	const images = [
		ln1, 
		ln2, 
		ln3, 
		ln4, 
		ln5];
	return (
		<div>
			<Slider {...settings}>
				{images.map((image,index) =>(
					<div key={index} className='container12'>
						<img src={image} alt='logo' className='h-12 w-32' />
					</div>
				))}
			</Slider>
		</div>
	)
}

export default LogoSlider